import React from 'react';
import { Backdrop, CircularProgress, makeStyles, createStyles } from '@material-ui/core';

// CSSスタイルを定義
const useStyles = makeStyles((theme) =>
  createStyles({
    backDrop: {
      zIndex: theme.zIndex.drawer + 1,
      color: '#fff',
    },
  }),
);

const Loading = React.memo(function Loading({ open }) {
  const classes = useStyles();

  return (
    <Backdrop className={classes.backDrop} open={open}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
});

Loading.displayName = 'Loading';

export default Loading;
